import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, Transition as _Transition, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54a7baa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-layout" }
const _hoisted_2 = { class: "spinner-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountForm = _resolveComponent("AccountForm")!
  const _component_BaseBookingLayout = _resolveComponent("BaseBookingLayout")!
  const _component_Account = _resolveComponent("Account", true)!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_BaseLayout = _resolveComponent("BaseLayout")!
  const _component_AccountBookingAmendment = _resolveComponent("AccountBookingAmendment")!
  const _component_AccountBookingCancel = _resolveComponent("AccountBookingCancel")!
  const _component_AccountConfirmationEmail = _resolveComponent("AccountConfirmationEmail")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseLayout, null, {
      default: _withCtx(() => [
        (!_ctx.isLoggedIn)
          ? (_openBlock(), _createBlock(_component_BaseBookingLayout, {
              key: 0,
              mainColumnWidth: 4
            }, {
              main: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_AccountForm, {
                    enableCreate: false,
                    isAgent: _ctx.isAgent
                  }, null, 8, ["isAgent"])
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_Transition, {
              key: 1,
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_Suspense, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Account, { isAgent: _ctx.isAgent }, null, 8, ["isAgent"])
                  ]),
                  fallback: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_BaseSpinner, { size: 40 })
                    ])
                  ]),
                  _: 1
                }))
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_AccountBookingAmendment),
    _createVNode(_component_AccountBookingCancel),
    _createVNode(_component_AccountConfirmationEmail)
  ], 64))
}